// extracted by mini-css-extract-plugin
module.exports =  {"loading":"loading_PGfZUsiI","container":"container_sefyvBFF","availableTemplates":"availableTemplates_YfE07cqm"};